import { useEffect, useRef, useState } from 'react'
import OutsideClickComponent from '../../fragments/OutsideClickComponent'
import classes from './CustomSelect.module.css'
import { generalAsyncSearch, getCollectionsForWorkQFilters } from '../../../lib/fetchApi'
import { formatAsyncSearchOption } from '../../../lib/lawFirmSearchOptions'
import LawFirmSearchOptionLabel from '../LawFirmSearchOptionLabel'
import { useSelector } from 'react-redux'

export default function CustomSelectAsync({label, identifier, action, path, fixedDrawer, name, reverseDrawer, rtlDrawer, preSelectedValue, isCollections}) {
    const containerRef = useRef(null)
    const toFocus = useRef(null)

    const userToken = useSelector(state => state.user.token)

    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
        width: null
    })

    const [showDrawer, setShowDrawer] = useState(false)
    const [selectedHidden, setSelectedHidden] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [selectedValue, setSelectedValue] = useState([])
    const [loading, setLoading] = useState(false)
    const [noOptionsFound, setNoOptionsFound] = useState(false)


    const [options, setOptions] = useState(null)

    const typingTimerRef = useRef()
    const doneTypingInterval = 500;  //time in ms, 5 seconds for example
    function changeInputhandler(event) {

        
        setInputValue(event.target.value ? event.target.value : '')
        clearTimeout(typingTimerRef.current); 
        if (event.target.value && event.target.value != '') {            
            typingTimerRef.current = setTimeout(search.bind(this, event.target.value), doneTypingInterval);
        } else {
            setOptions(null)
        }       

   
    }

    async function search(inputValue)  {   
        setLoading(true)
        let values = []
        setNoOptionsFound(false)
        

        if (!isCollections) {
            const searchedData = await generalAsyncSearch(userToken, path, inputValue)
    
            if (searchedData && searchedData.length) {
                searchedData.forEach(element => {
                    values.push(formatAsyncSearchOption(element, path))
                });
                
            } else {
                setNoOptionsFound(true)
            }
        } 

        if (isCollections) {
            const searchedData = await getCollectionsForWorkQFilters(userToken, path, inputValue)
            if (searchedData && searchedData.length) {
                searchedData.forEach(element => {
                    let item = {
                        label: element.name,
                        value: element.id,
                        tag: path,
                        id: element.id
                    }
                    values.push(item)
                });                
            } else {
                setNoOptionsFound(true)
            }
        }

        if (values && values.length) {
            setOptions(values)
        } else {
            setOptions(null)
        }

        setLoading(false)
    }

    const justToggledClosedByMouseDownRef = useRef(false)

    function focusSelectOnClickHandler() {
        if (justToggledClosedByMouseDownRef.current) {
            justToggledClosedByMouseDownRef.current = false
            return
        }
        if (showDrawer) return
        setShowDrawer(true)
        setSelectedHidden(true)
        if (toFocus && toFocus.current) {
            toFocus.current.focus()
        }
    }

    function toggleOnMouseDownHandler(event) {
        if (showDrawer) {
            event.preventDefault()
            justToggledClosedByMouseDownRef.current = true
            blurHandler()
            toFocus.current?.blur()
        }
    }

    function focusHandler(e) {
        setShowDrawer(true)
        setSelectedHidden(true)

        if (fixedDrawer) {
            if (containerRef && containerRef.current) {
                let left = containerRef.current.getBoundingClientRect().left
                let bottom = containerRef.current.getBoundingClientRect().bottom
                let width = containerRef.current.getBoundingClientRect().width

                setCoordinates({
                    top: bottom + 4,
                    left: left,
                    width: width
                })
            }
        }
        
    }
    function blurHandler() {
        setShowDrawer(false)
        setSelectedHidden(false)
    }

    function removeSingleSelected(item, event) {
        event?.stopPropagation?.()
        event?.preventDefault?.()

        const nextSelected = selectedValue.filter((val) => val.value != item.value)
        setSelectedValue(nextSelected)
        setInputValue('')
        setShowDrawer(false)
        setSelectedHidden(false)
        setOptions(null)

        if (action) {
            action({
                data: {
                    value: nextSelected,
                },
                identifier: identifier,
                options: nextSelected,
            })
        }
    }

    function setOptionHandler(item) {
        setInputValue('')
        setShowDrawer(false)
        setSelectedHidden(false)
        setOptions(null)

        let optionAllreadySelected = selectedValue?.find(val => val.value === item.value)

        if (optionAllreadySelected) {
            removeSingleSelected(item)
        } else {  
            setSelectedValue(prevArr => prevArr = [...prevArr, item])
            if (action && item) {
                item.path = path
                action({
                    data: {
                        value: item
                    },
                    identifier: identifier,
                    option: item
                })
            } 
        } 
    }

    function normalizePreselectedItem(item) {
        return {
            label: item.label ?? item.item?.label,
            value: item.value ?? item.id ?? item.item?.value,
            tag: item.tag ?? item.item?.tag ?? path,
            id: item.id ?? item.value ?? item.item?.id,
        }
    }

    useEffect(() => {
        if (preSelectedValue && preSelectedValue.length) {
            setSelectedValue(preSelectedValue.map(normalizePreselectedItem))
        } else {
            setSelectedValue([])
        }
    }, [preSelectedValue])
    
    
    return <div className={`${classes.container} ${(showDrawer || (selectedValue && selectedValue.length > 0)) ? classes.is_focused : ''} ${!label && classes.no_label_container}   `} >
        <OutsideClickComponent task={blurHandler}>   
            <div ref={containerRef} className={`${classes.input_container}`} onMouseDown={toggleOnMouseDownHandler} onClick={focusSelectOnClickHandler}>
                {label && <div className={`${classes.label} label`}>{label}</div>}
                <div className={`${classes.input_container_multiple}`}>

                    {selectedValue && selectedValue.length > 0 && <>
                        {selectedValue.map((item, chipIndex) => (
                            <span
                                key={`chip_${String(item.value ?? 'null')}_${chipIndex}`}
                                className={classes.selected_single_item}
                            >
                                <span className={classes.chip_label}>{item.label}</span>
                                <button
                                    type="button"
                                    className={classes.chip_remove_btn}
                                    title="Remove"
                                    aria-label={`Remove ${item.label}`}
                                    onClick={(e) => removeSingleSelected(item, e)}
                                >
                                    <i className="ti ti-x"></i>
                                </button>
                            </span>
                        ))}
                    </>}

                    <input ref={toFocus} name={name} type='text' onChange={changeInputhandler} onFocus={focusHandler} className={classes.input} value={inputValue} autoComplete="off"/>

                </div>       

                <div className={`select_pointer ${classes.pointer} ${showDrawer && classes.opened}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            {showDrawer && <div className={`${classes.drawer} ${reverseDrawer ? classes.reverse_drawer : ''} ${rtlDrawer ? classes.rtl_drawer : ''} ${fixedDrawer ? classes.fixed : ''}`} style={{top: coordinates.top, left: coordinates.left, width: coordinates.width}}>
                {loading && <div className={classes.drawer_loading}>Loading...</div>}
                
                {!loading && <>
                    {noOptionsFound && <div className={classes.drawer_instructions}>No results found</div>}
                    {options && !noOptionsFound && options.filter(item => !item.isDisabled).map(item => (
                        <div key={item.value}>
                            <button type='button' onClick={setOptionHandler.bind(this, item)} className={`${classes.option} ${(selectedValue && (selectedValue.value == item.value)) ? classes.option_selected : ''}`}>
                                {path === 'law-firms'
                                    ? <LawFirmSearchOptionLabel label={item.label} code={item.code} name={item.name} verified={item.verified} />
                                    : item.label}
                            </button>
                        </div>
                    ))}
                    {!options && !noOptionsFound && preSelectedValue && preSelectedValue.length > 0 && preSelectedValue.map(item => (
                        <div key={item.value}>
                            <button type='button' onClick={setOptionHandler.bind(this, normalizePreselectedItem(item))} className={`${classes.option} ${(selectedValue && (selectedValue.find(val => val.value === item.value))) ? classes.option_selected : ''}`}>{item.label ?? item.item?.label}</button>
                        </div>
                    ))}
                    {!options && !noOptionsFound && !preSelectedValue && <div className={classes.drawer_instructions}>Start typing to search</div>}
                </>}
            </div>}
        </OutsideClickComponent>
    </div>
}
